import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import { AlertCircle, Mail, Shield, ArrowRight } from 'lucide-react';
import './HomePage.css'; // Reutilizamos el mismo CSS

const API_URL = process.env.REACT_APP_API_URL;

const LoginPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, login } = useContext(AuthContext);
  
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  // Si ya está autenticado, redirigir a gestión de clientes
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/gestion-clientes');
    }
  }, [isAuthenticated, navigate]);
  
  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      // ✅ URL CORRECTA - sin duplicación y sin puerto
      const response = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Error al iniciar sesión');
      }
      
      login(data.token, data.user);
      
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-standalone">

      {/* Contenido principal */}
      <main className="login-page-main">
        <div className="container">
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br> 
          <br></br>
          <div className="login-page-content">

            {/* Formulario usando la misma estructura que HomePage */}
            <div className="login-form-container">
              <div className="login-header">
                <h2>Accede a tu plataforma</h2>
                <p>Gestiona todos tus pedidos médicos desde un solo lugar</p>
              </div>

              <form onSubmit={handleLogin} className="login-form-modern">
                {error && (
                  <div className="error-alert">
                    <AlertCircle size={18} />
                    {error}
                  </div>
                )}

                <div className="form-field">
                  <div className="field-icon">
                    <Mail size={18} />
                  </div>
                  <input 
                    type="text" 
                    placeholder="Usuario o email" 
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                  />
                </div>

                <div className="form-field">
                  <div className="field-icon">
                    <Shield size={18} />
                  </div>
                  <input 
                    type="password" 
                    placeholder="Contraseña" 
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>

                <div className="form-options">
                  <a href="#recuperar" className="forgot-link">¿Olvidaste tu contraseña?</a>
                </div>

                <button 
                  type="submit" 
                  className={`btn-login ${loading ? 'loading' : ''}`}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <div className="spinner-login"></div>
                      Accediendo...
                    </>
                  ) : (
                    <>
                      <ArrowRight size={18} />
                      Acceder a mi cuenta
                    </>
                  )}
                </button>
              </form>

              <div className="login-footer">
                <p>¿Tu centro médico no tiene cuenta?</p>
                <Link to="/register" className="register-link">
                  Solicita acceso gratuito aquí
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default LoginPage;